import { render, staticRenderFns } from "./NearbyAreas.vue?vue&type=template&id=50fe63f2&scoped=true"
import script from "./NearbyAreas.vue?vue&type=script&lang=ts"
export * from "./NearbyAreas.vue?vue&type=script&lang=ts"
import style0 from "./NearbyAreas.vue?vue&type=style&index=0&id=50fe63f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe63f2",
  null
  
)

export default component.exports